import { ERROR_CODES } from "../config/constants";

export const normalizeCatchErrors = (error: any) => {
  let errorPayload;
  if (
    error &&
    error.data &&
    error.data.code === ERROR_CODES.UNABLE_TO_AUTHENTICATE_MFA_INPUT
  ) {
    errorPayload = error.data.message || ["Something went wrong"];
  } else if(error && error.data && error.data.message){
    errorPayload = error.data.message || ["Something went wrong"];
  } else if (error && error.data) {
    errorPayload = error.data.error
      ? error.data.error
      : error.data.errors || ["Something went wrong"];
  } else {
    errorPayload = ["Something went wrong"];
  }
  return {
    errorFullResponse: error && error.data,
    status: error ? error.status || 0 : 0,
    statusText: error ? error.statusText || "" : "",
    errors:
      errorPayload instanceof Array
        ? errorPayload
        : [JSON.stringify(errorPayload, null, 4)],
    errorCode: error && error.data.code || "",
    errorValue: error && error.data.values && error.data.values.MIN_ORDER_VAL || "",
}
}
